import DetailsTitle from "components/common/detailsPage/DetailsTitle";
import DetailsShimmer from "components/common/shimmer/DetailsShimmer";
import { CustomerStatusBadge } from "components/common/StatusBadge";
import { usePermission } from "hooks/usePermission";
import { useQueryParam } from "hooks/useQueryParam";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerDetails } from "store/slices/customersSlice";
import { formatUTCDate } from "utils/utils";
import InfoItem from "components/common/detailsPage/InfoItem";
import NoPermission from "components/common/NoPermission";
import Vehicles from "../Customers/Details/Vehicles";
import LeadVehicleDetails from "./LeadVehicleDetails";
import IsLoading from "components/common/IsLoading";

const LeadDetails = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const id = useQueryParam("id");

  const { canAction } = usePermission();
  const { canView } = canAction("customers");

  const { loading, itemDetails } = useSelector((state) => state.Customers);

  const {
    name,
    phone,
    status,
    lastLoggedIn,
    createdAt,
    deviceInfo,
    loyaltyPointsSummary,
  } = itemDetails || {};
  const {
    appVersion,
    language: deviceLanguage,
    model,
    osVersion,
    platform,
  } = deviceInfo || {};
  const { totalEarned, totalRedeemed, balance } = loyaltyPointsSummary || {};

  const [activeTab, setActiveTab] = useState(1);

  useEffect(() => {
    if (id && canView) {
      dispatch(getCustomerDetails(id));
    }
  }, [id, canView]);

  const infoFields = [
    {
      label: t("Name"),
      value: name,
      col: { lg: 6, md: 3, xs: 6 },
    },
    {
      label: t("Phone Number"),
      value: phone,
      col: { lg: 6, md: 3, xs: 6 },
    },
    {
      label: t("Last Login Date"),
      value: lastLoggedIn ? formatUTCDate(lastLoggedIn) : "-",
      col: { lg: 6, md: 3, xs: 6 },
    },
    {
      label: t("Created Date"),
      value: createdAt ? formatUTCDate(createdAt) : "-",
      col: { lg: 6, md: 3, xs: 6 },
    },
    {
      label: t("App Version"),
      value: appVersion,
      col: { lg: 6, md: 3, xs: 6 },
    },
    {
      label: t("Status"),
      render: <CustomerStatusBadge status={status} t={t} />,
      col: { lg: 6, md: 3, xs: 6 },
    },

    { isSpacer: true },

    {
      label: t("Language"),
      value: deviceLanguage,
      col: { lg: 6, md: 3, xs: 6 },
    },
    {
      label: t("Platform"),
      value: platform,
      col: { lg: 6, md: 3, xs: 6 },
    },
    {
      label: t("OS Version"),
      value: osVersion,
      col: { lg: 6, md: 3, xs: 6 },
    },
    {
      label: t("Model"),
      value: model,
      col: { lg: 12, md: 12, xs: 12 },
    },
  ];
  const shimmerLayout = [
    {
      col: 12,
      blocks: [
        { rows: 1, cols: 6 },
        { rows: 1, cols: 5 },
      ],
    },
    {
      col: 12,
      blocks: [{ rows: 1, cols: 3 }],
    },
    {
      col: 12,
      type: "details_page_tab",
      blocks: [{ rows: 1, cols: 1 }],
    },
  ];

  if (!canView) return <NoPermission />;

  if (loading) {
    return (
      <div className="page-content">
        <DetailsTitle title={t("Lead Details")} />
        <IsLoading />
      </div>
    );
  }

  return (
    <div className="page-content common_details_page customer_details">
      <DetailsTitle title={t("Lead Details")} />
      <Row>
        <Col lg={5}>
          <div className="common_card lead_detail_card">
            <h2 className="title_20 mb-4">{t("General Details")}</h2>
            <Row className="details_page_item_row">
              {infoFields.map((item, index) => {
                if (item.isSpacer) {
                  return <div key={index} className="mt-4 w-100" />;
                }

                return (
                  <InfoItem
                    key={index}
                    label={item.label}
                    value={item.value}
                    col={item.col}
                    classname="mb-2"
                  >
                    {item.render}
                  </InfoItem>
                );
              })}
            </Row>
          </div>
        </Col>
        <Col lg={7}>
          <div className="common_card lead_detail_card">
            <h2 className="title_20 mb-4">{t("Vehicle List")}</h2>

            {activeTab === 1 && <LeadVehicleDetails id={id} />}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LeadDetails;
